module.exports = __webpack_public_path__ + "static/logo-bridge-no-text-49c3a6ae35fbf2916540454cddd63d97.png";